import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuth } from 'firebase/auth';

import { ApiResponse } from 'src/types/api-response';
import { ROUTE, Params, Result } from 'api/auth/session-out/params';

import { api } from 'src/utils/api';
import { app as firebaseApp } from 'src/firebase-client';

export const signOut = createAsyncThunk<ApiResponse<Result>, Params, { rejectValue: string }>(
  'user/signOut',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.sendRequest<Result>({ url: ROUTE, method: 'POST', data });

      if (response.success) {
        await getAuth(firebaseApp).signOut();
        return response;
      }

      throw new Error('SignInError');
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }
  }
);
